<template>
    <div class="reportsMap">
        <div class="container">
            <div class="center">
                <div class="center_header_title">
                    <span>{{title1}}</span>
                    <span class="headerTitle">{{title2}}</span>
                    <div class="helpDiv">
                       <!--  <img :src="wikiIcon" class="helpImg"/> -->
                        <b class="helpI"></b>
                        <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=28050677" 
                        target="_blank"
                        class="helpA">
                            帮助指引
                        </a>
                    </div>
                </div>
                <div class="center_foot_left">
                    <span>生成时间: {{generateTime}}</span>
                </div>
                <div class="center_foot_right">
                    <span>itsmops.autoai.com</span>
                </div>
                <p></p>
                <div class="center_container_left">
                    <el-date-picker
                        id="dddd"
                        v-model="value1"
                        type="daterange"
                        @change="showTime"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="margin: 0 auto 10px auto"
                    >
                    </el-date-picker>
                    <el-button @click="clickShow" type="primary" style="margin-left: 20px">修改时间</el-button>
                    <el-button @click="exportTable(title2,value1[0],`—${value1[1]}`)" type="primary">导出表格</el-button>
                    <el-table :data="tableData" border
                              id="out_export" >
                        <el-table-column prop="name"    min-width="95"></el-table-column>
                        <el-table-column prop="reception" label="服务台完成" sortable  :sort-orders="sortList" min-width="120"></el-table-column>
                        <el-table-column prop="firstLine" label="一线完成" sortable  :sort-orders="sortList" min-width="120"></el-table-column>
                        <el-table-column prop="secondLine" label="二线完成" sortable :sort-orders="sortList" min-width="130"></el-table-column>
                        <el-table-column prop="thirdLine" label="三线完成" sortable :sort-orders="sortList" min-width="130"></el-table-column>
                        <el-table-column prop="thirdPart" label="转第三方" sortable :sort-orders="sortList" min-width="130"></el-table-column>
                    </el-table>
                </div>
                <!--<div class="center_container_right">-->
                    <!--<div style="width: 100%;height: 300px" ref="chart" class="chart"></div>-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import services from './eventReportDetailed.service'
    export default {
        data(){
            return{
                value1:'',
                tableData:[],
                sortList:['ascending', 'descending'],
                generateTime:'',
                title1:'事件报表细化',
                title2:'事件分类统计',
            }
        },
        created(){

        },
        mounted(){
            // this.initChart()
            this.getDeafultTime()
        },
        methods:{
            exportTable(name,startTime,endTime=''){
                this.$exportTable(name,startTime,endTime)
            },
            getDeafultTime(){
                let nowdays = new Date();
                let year = nowdays.getFullYear();
                let month = nowdays.getMonth();
                if(month==0) {
                    month=12;
                    year=year-1;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                let firstDay = year + "-" + month + "-" + "01";//上个月的第一天
                let myDate = new Date(year, month, 0);
                let lastDay = year + "-" + month + "-" + myDate.getDate();//上个月的最后一天
                let params={
                    startTime:firstDay,
                    stopTime:lastDay
                }
                this.value1=[firstDay,lastDay]
                // console.log(params);
                services.classifyStatistics(params).then(res=>{
                    this.generateTime=res.generateTime
                    this.tableData=res.tableData

                })
            },
            //点击修改时间触发时间选择器focus事件
            clickShow(){
                let d=document.getElementById('d')//获取到时间选择器里的input
                d.focus()
            },
            showTime(){
                // console.log(this.value1);
                let params={
                    startTime:this.value1[0],
                    stopTime:this.value1[1]
                }
                services.classifyStatistics(params).then(res=>{
                    this.generateTime=res.generateTime
                    this.tableData=res.tableData

                })
            },

        }
    }
</script>

<style scoped lang="scss">
    .reportsMap{
        margin-top: 20px;
        width: 100%;
        height: auto;
        background: white;
        position: relative;
        overflow: hidden;
        .container{
            width: 90%;
            /*height: 80%;*/

            .center{
                width: 100%;
                min-height: 80%;
                height: auto;
                background: white;
                position: relative;
                margin: 4% 6%;

                border-top: 1px solid rgb(158,195,240);
                border-bottom: 1px solid rgb(158,195,240);
                .center_header_title{
                    position: absolute;
                    top: -26px;
                    left: 0;
                    color: black;
                    font-size: 16px;
                    .headerTitle{
                        margin-left: 20px;
                        color: #1890ff;
                    }

                }
                .center_container_left{
                    /*width: 50%;*/
                    margin: 20px 0 20px 0;

                }
                /*.center_container_right{*/
                    /*width: 50%;*/

                /*}*/
                .center_foot_left{
                    position: absolute;
                    bottom: -26px;
                    left: 0;
                    color: grey;
                    font-size: 16px;
                }
                .center_foot_right{
                    position: absolute;
                    bottom: -26px;
                    right: 0;
                    color: grey;
                    font-size: 16px;
                }
                p{
                    position: absolute;
                    top: -26px;
                    right: 0;
                    width: 100px;
                    height: 22px;
                    background: url('../../../../assets/icon_logo.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }

</style>
